import { goToPrevioIDLogout } from '~/composables/PrevioID'
import { resolveDefaultRoute } from '~/router/defaultRoute'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

const entryPoint = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const defaultRoute = resolveDefaultRoute()

  if (defaultRoute === null) {
    goToPrevioIDLogout()

    return
  }

  return next({ name: defaultRoute })
}

export default entryPoint
